import React from 'react';
import { Provider } from 'react-redux';
import { useParams } from 'react-router-dom';
import { studioStore } from '../../components/StudioPro/store/studioStore';
import StudioPro from '../../components/StudioPro';
import '../../components/StudioPro/StudioPro.css';

function EventEditor2() {
  const { eventId } = useParams();
  const auth = localStorage.getItem('_auth');

  const token = auth ? JSON.parse(auth).token : null; // Remplacez par le token réel de l'utilisateur connecté
  const apiBaseUrl = process.env.REACT_APP_API_URL; // Remplacez par l'URL de base de votre REST API

  return (
    <div className="App" style={{ width: '100%', height: '100%' }}>
      <Provider store={studioStore}>
        <StudioPro
          token={token}
          apiBaseUrl={apiBaseUrl}
          eventId={eventId}
          documentId={null}
          onDocumentSaved={(doc) => {
            console.log('Document saved:', doc);
          }}
        />
      </Provider>
    </div>
  );
}

export default EventEditor2;
